








//eslint-disable @typescript-eslint/no-explicit-any
import Vue from "vue";
import WhatsRedirect from "./components/template/whatsredirect.vue";
import auth from "./components/template/auth.vue";
import loading from "./components/template/loading.vue";

import { mapState } from "vuex";
export default Vue.extend({
  name: "AppBase",

  components: {
    WhatsRedirect,
    auth,
    loading
  },

  data: () => ({
    localLoading: false,
    checkingLogin: false
  }),
  computed: {
    ...mapState({
      isLoading: (state: any) => state.appStore.isLoading,
      isLoggedIn: (state: any) => state.appStore.isLoggedIn
    })
  },
  async mounted() {
    await this.$store.dispatch("appStore/checkIfUserIsLoggedIn");
  }
});
